import { NgClass, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

/**
 * @prop {string} label - the text to display in the header label.
 * @prop {string} useElementH - set the element <h> tag to use for the header label. (Default is <h3>) | useElementH: '1' | '1' to '6' can be used.
 * @prop {string} class - optional passed in class to apply to the header label.
 * @prop {boolean} danger - set whether the header label should be styled as danger. (Red Font)
 * @prop {boolean} useSecondaryColor - set whether the header label should use the secondary color  (gray-600).
 * @prop {boolean} underline - set whether the header label should be underlined. (underline the actual <h> text)
 * @prop {boolean} bold - set whether the header label should be bold.
 * @prop {boolean} useDefaultLineColor - set whether the header label should use the default line color.
 * @prop {boolean} horizontalLine - set whether a horizontal line should be displayed.
 * @prop {number} horizontalLineSpacing - set the spacing for the horizontal line.
 * @prop {number} marginTop - set the margin top for the header label.
 * @prop {number} marginBottom - set the margin bottom for the header label.
 */

@Component({
	selector: 'formly-field-header-label',
	template: `
		<div [ngSwitch]="to?.useElementH" class="linq-mt-{{ to.marginTop || 1 }} linq-mb-{{ to.horizontalLine ? 0 : to.marginBottom || 1 }}">
			<div *ngSwitchCase="'1'">
				<h1 class="{{ to.class }}" [ngClass]="{ danger: to.danger, secondary: to.useSecondaryColor, underline: to.underline, bold: to.bold }">
					{{ to.label }}
				</h1>
			</div>
			<div *ngSwitchCase="'2'">
				<h2 class="{{ to.class }}" [ngClass]="{ danger: to.danger, secondary: to.useSecondaryColor, underline: to.underline, bold: to.bold }">
					{{ to.label }}
				</h2>
			</div>
			<div *ngSwitchCase="'4'">
				<h4 class="{{ to.class }}" [ngClass]="{ danger: to.danger, secondary: to.useSecondaryColor, underline: to.underline, bold: to.bold }">
					{{ to.label }}
				</h4>
			</div>
			<div *ngSwitchCase="'5'">
				<h5 class="{{ to.class }}" [ngClass]="{ danger: to.danger, secondary: to.useSecondaryColor, underline: to.underline, bold: to.bold }">
					{{ to.label }}
				</h5>
			</div>
			<div *ngSwitchCase="'6'">
				<h6 class="{{ to.class }}" [ngClass]="{ danger: to.danger, secondary: to.useSecondaryColor, underline: to.underline, bold: to.bold }">
					{{ to.label }}
				</h6>
			</div>
			<div *ngSwitchDefault>
				<h3 class="{{ to.class }}" [ngClass]="{ danger: to.danger, secondary: to.useSecondaryColor, underline: to.underline, bold: to.bold }">
					{{ to.label }}
				</h3>
			</div>
		</div>
		<div *ngIf="to.horizontalLine" class="linq-mt-{{ to.horizontalLineSpacing || 1 }} linq-mb-{{ to.marginBottom || 1 }}">
			<hr [ngClass]="{ danger: to.danger, bold: to.bold, secondary: to.useSecondaryColor, default: to.useDefaultLineColor }" />
		</div>
	`,
	styleUrls: ['./header-label-type.component.less'],
	standalone: true,
	imports: [NgClass, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault],
})
export class FormlyFieldHeaderLabelComponent extends FieldType {}
